import api from '../../api'

// initial state
const state = {
  all: []
}

// getters
const getters = {
  allCategories: state => state.all,
  getProductCategory: state => id => {
    return state.all.find(item => item.id === id)
  }
}

// actions
const actions = {
  getAllCategories({ commit }) {
    console.info('getAllCategories')
    if (!state.all.length) {
      console.info('Got all categories 1')
      api.get('categories', categories => {
        console.info('Got all categories')
        console.info(categories)
        commit('setCategories', categories)
      })
    } else {
      console.info('Didnt get all categories')
    }
  }
}

// mutations
const mutations = {
  setCategories(state, categories) {
    state.all = categories
  },
  incrementProductQuantityInCart(state, payLoad) {
    // for some reasons payLoad.product.categoryId is a string hence parseInt
    const category = state.all.find(
      item => item.id === parseInt(payLoad.product.categoryId)
    )
    if (category) {
      const product = category.products.find(
        product => product.id === payLoad.product.id
      )
      if (!product.quantityInCart) {
        product.quantityInCart = payLoad.quantity
      } else {
        product.quantityInCart += payLoad.quantity
      }
    }
  },
  clearProductQuantityInCart(state, payLoad) {
    // console.info('clearProductQuantityInCart')
    const categoriesCopy = state.all
    const category = categoriesCopy.find(
      category => category.id === payLoad.product.categoryId
    )
    const product = category.products.find(
      product => product.id === payLoad.product.id
    )
    product.quantityInCart = 0
    state.all = []
    state.all = state.all.concat(categoriesCopy)
  },
  clearAllProductsQuantityInCart(state) {
    const categoriesCopy = state.all
    categoriesCopy.forEach(category => {
      category.products.forEach(product => {
        product.quantityInCart = 0
      })
    })
    state.all = []
    state.all = state.all.concat(categoriesCopy)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/categories.js